import { render, staticRenderFns } from "./Talks.vue?vue&type=template&id=6ff3237c&"
import script from "./Talks.vue?vue&type=script&lang=ts&"
export * from "./Talks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports